import { makeStyles } from '@material-ui/core/styles';

interface IStylesProps {
  totalColor: string;
  percentColor: string;
}

export const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: '12px 17px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  footer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  title: {
    color: '#37474F',
  },
  total: (props: IStylesProps) => ({
    color: props.totalColor,
  }),
  percent: (props: IStylesProps) => ({
    color: props.percentColor,
    height: 32,
  }),
}));
